<template>
  <div class="login-page-wrapper">
    <div class="login-container">
      <h2 class="title">Login Aplikasi Perbankan</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="email">Email:</label>
          <input id="email" type="email" v-model="email" required />
        </div>
        <div class="form-group">
          <label for="password">Password:</label>
          <input id="password" type="password" v-model="password" required />
        </div>
        <button type="submit" class="btn btn-primary">Login</button>
        <p v-if="error" class="error-message">{{ error }}</p>
      </form>
      
      <div class="register-link-container">
        Belum punya akun? 
        <router-link to="/register" class="register-link">Daftar di sini</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useRouter } from 'vue-router';

const email = ref('');
const password = ref('');
const error = ref(null);
const authStore = useAuthStore();
const router = useRouter();

const handleLogin = async () => {
  error.value = null;
  try {
    await authStore.login({ email: email.value, password: password.value });
    await router.push('/dashboard');
    window.location.reload(); // Paksa refresh untuk state yang bersih
  } catch (err) {
    error.value = 'Email atau password salah. Silakan coba lagi.';
    console.error('Login failed:', err);
  }
};
</script>

<style scoped>
  .login-page-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f4f7f6;
  }
  .login-container {
    width: 100%;
    max-width: 400px;
    margin: 1rem;
    padding: 2rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  .title {
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
    color: #2c3e50;
  }
  
  /* Menggunakan style dari global.css, tapi bisa di-override di sini */
  .form-group { margin-bottom: 1rem; }
  
  button.btn-primary {
    width: 100%;
    margin-top: 1rem;
  }
  
  .error-message {
    color: #dc3545;
    text-align: center;
    margin-top: 1rem;
  }

  .register-link-container {
    text-align: center;
    margin-top: 1.5rem;
    font-size: 0.9rem;
    color: #555;
  }
  .register-link {
    color: #007bff;
    font-weight: 500;
    text-decoration: none;
  }
  .register-link:hover {
    text-decoration: underline;
  }
</style>